import { store } from '../store/store';
import { HttpRequest } from '../utils';

const httpRequest = new HttpRequest(store);

export const valuate = async (values: any) => {
  const res = await httpRequest.post('/api/valuation/valuate', values);
  return res;
};

export const get = async (id: string) => {
  const res = await httpRequest.get(`/api/valuation/${id}/detail`);
  // hasVat: boolean;
  // amountVat: number | string;
  return res;
};

export const calculate = async ({
  amount,
  percentBranchHead,
  percentOdo,
  hasVat = false
}: {
  amount: number;
  percentBranchHead: number;
  percentOdo: number;
  hasVat: boolean;
}) => {
  const res = await httpRequest.get('/api/valuation/calculate', {
    amount,
    percentBranchHead,
    percentOdo,
    hasVat: false
  });
  return res.calculatedAmount;
};

export const list = async (data: { page: number; limit: number; query?: string }) => {
  const res = await httpRequest.get('/api/valuation', data);
  return res;
};

export const finalize = async ({
  id,
  percentOdo,
  percentBranchHead,
  imageUrls,
  hasVat = false
}: {
  id: string;
  percentOdo?: number;
  percentBranchHead: number;
  imageUrls?: string[];
  hasVat: boolean;
}) => {
  return httpRequest.put(`/api/valuation/${id}/finalize`, {
    percentBranchHead: percentBranchHead,
    percentOdo: percentOdo,
    imageUrls: imageUrls,
    hasVat: false
  } as any);
};

export const selectSequence = async (payload: any) => {
  const res = await httpRequest.get(`/api/sequence/select`, {
    ...payload,
    limit: 10000,
  });
  return res;
};

export const pdf = async (id: string) => {
  const res = await httpRequest.put(`/api/valuation/${id}/pdf`);
  return res;
};

export const send = async ({ id, values }: { id: string; values: any }) => {
  const res = await httpRequest.put(`/api/valuation/${id}/send`, values);
  return res;
};

//

export const reject = async (values: { reason: string; note: string }, valuationId: string) => {
  const res = await httpRequest.put(`/api/valuation/${valuationId}/reject`, values);
  return res;
};

export const returned = async (data: { reason: string; note: string }, valuationId: string) => {
  const res = await httpRequest.put(`/api/valuation/${valuationId}/return`, data);
  return res;
};

export const returnCustomer = async (data: { reason: string }, valuationId: string) => {
  const res = await httpRequest.put(`/api/valuation/${valuationId}/return_customer`, data);
  return res;
};

export const appraise = async (
  data: {
    comparativeVehicles: {
      brandModel: string;
      manufacturedYear: number;
      importedYear: number;
      odo: number;
      price: number;
      sourceUrl: string;
    }[];
    priceFinal: number;
    conclusion: string;
    send: boolean;
  },
  valuationId: string
) => {
  const res = await httpRequest.put(`/api/valuation/${valuationId}/appraise`, data);
  return res;
};


export const branchPercentConfirm = async (valuationId: string) => {
  const res = await httpRequest.put(`/api/valuation/${valuationId}/branch_percent_confirm`);
  return res;
};




// valuation/:id/appraise
